import { render, staticRenderFns } from "./DeviceAlarm.vue?vue&type=template&id=23afcc72&scoped=true&"
import script from "./DeviceAlarm.vue?vue&type=script&lang=js&"
export * from "./DeviceAlarm.vue?vue&type=script&lang=js&"
import style0 from "./DeviceAlarm.vue?vue&type=style&index=0&id=23afcc72&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23afcc72",
  null
  
)

export default component.exports